(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.componentPropTypes = exports.oneOfProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__(11);

var oneOfProps = exports.oneOfProps = {
  colour: ['green-light', 'green', 'green-medium', 'green-dark', 'yellow', 'yellow-dark', 'pink', 'pink-dark', 'red', 'red-dark', 'purple', 'purple-medium', 'purple-dark', 'orange', 'orange-medium', 'orange-dark', 'blue', 'blue-medium', 'blue-dark', 'white', 'almost-light', 'grey-light', 'grey', 'grey-medium', 'grey-dark', 'almost-black'],
  textSize: ['small']
};

var componentPropTypes = exports.componentPropTypes = {
  colour: _propTypes2.default.oneOf(oneOfProps.colour).isRequired,
  raised: _propTypes2.default.bool,
  outlined: _propTypes2.default.bool,
  unstyled: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  textSize: _propTypes2.default.oneOf(oneOfProps.textSize),
  fullWidth: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.any.isRequired
};

var defaultProps = exports.defaultProps = {
  colour: 'grey-medium',
  raised: false
};

var setClassName = function setClassName(props) {
  return (0, _classnames2.default)('button', { 'button--disabled': props.disabled }, { 'button--unstyled': props.unstyled }, _defineProperty({}, 'button--' + props.colour, props.colour && props.colour !== 'default' && !props.unstyled && !props.disabled), {
    'button--raised': props.raised && !props.unstyled && !props.disabled
  }, { 'button--outlined': props.outlined && !props.unstyled }, _defineProperty({}, 'button--' + props.textSize, props.textSize), { 'button--full-width': props.fullWidth }, props.className);
};

var addClassNameToProps = function addClassNameToProps(props) {
  return _extends({}, props, {
    className: setClassName(props)
  });
};

var Button = function Button(props) {
  var withOmitted = (0, _omit2.default)(['colour', 'raised', 'outlined', 'unstyled', 'textSize', 'fullWidth'])(addClassNameToProps(props));
  return props.href ? _react2.default.createElement(
    'a',
    withOmitted,
    props.children
  ) : _react2.default.createElement(
    'button',
    withOmitted,
    props.children
  );
};

Button.propTypes = componentPropTypes;
Button.defaultProps = defaultProps;

exports.default = Button;

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.componentPropTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__(6);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(25);

var componentPropTypes = exports.componentPropTypes = {};

var defaultProps = exports.defaultProps = {};

var IconList = function IconList(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'ul',
    { className: 'iconlist' },
    children
  );
};

IconList.propTypes = componentPropTypes;
IconList.defaultProps = defaultProps;

IconList.Item = function (_ref2) {
  var icon = _ref2.icon,
      children = _ref2.children;
  return (
    // Note that icon- clashes with global icon class, so using iconlist instead of icon-list
    _react2.default.createElement(
      'li',
      { className: 'iconlist__item' },
      _react2.default.createElement(
        'span',
        { className: 'iconlist__item-icon' },
        _react2.default.createElement(_Icon2.default, { icon: icon })
      ),
      ' ',
      _react2.default.createElement(
        'span',
        { className: 'iconlist__item-text text-milli' },
        children
      )
    )
  );
};

exports.default = IconList;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/fp/omit");

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.componentPropTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(5);

var componentPropTypes = exports.componentPropTypes = {
  icon: _propTypes2.default.string.isRequired
};

var Icon = exports.Icon = function Icon(props) {
  return _react2.default.createElement('span', { className: (0, _classnames2.default)('ss-icon', 'ss-' + props.icon) });
};

Icon.propTypes = componentPropTypes;

exports.default = Icon;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(4);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(76);


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.componentPropTypes = exports.oneOfProps = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(77);

var _Button2 = _interopRequireDefault(_Button);

var _IconList = __webpack_require__(78);

var _IconList2 = _interopRequireDefault(_IconList);

var _paletteWonderblyPalette = __webpack_require__(79);

var _paletteWonderblyPalette2 = _interopRequireDefault(_paletteWonderblyPalette);

__webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var oneOfProps = exports.oneOfProps = {
  colour: Object.keys(_paletteWonderblyPalette2.default),
  imageBackgroundSize: ['contain', 'cover'],
  largeImageSide: ['left', 'right']
};

var darkForegroundColours = oneOfProps.colour.filter(function (colour) {
  return colour.indexOf('light') > -1 || ['white', 'stone', 'yellow'].indexOf(colour) > -1;
});

var componentPropTypes = exports.componentPropTypes = {
  ageRange: _propTypes2.default.string.isRequired,
  badgeInline: _propTypes2.default.bool,
  badgeInlineBorder: _propTypes2.default.bool,
  badgeText: _propTypes2.default.string,
  body: _propTypes2.default.node.isRequired,
  colour: _propTypes2.default.oneOf(oneOfProps.colour),
  cta: _propTypes2.default.string,
  fadeButton: _propTypes2.default.bool,
  image: _propTypes2.default.string,
  imageBackgroundColour: _propTypes2.default.string,
  imageBackgroundSize: _propTypes2.default.oneOf(oneOfProps.imageBackgroundSize),
  large: _propTypes2.default.bool,
  largeImageSide: _propTypes2.default.oneOf(oneOfProps.largeImageSide),
  onClick: _propTypes2.default.func,
  onlyLinkInner: _propTypes2.default.bool,
  price: _propTypes2.default.string.isRequired,
  priceOriginal: _propTypes2.default.string,
  renderAppendix: _propTypes2.default.func,
  renderImage: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired
};

var defaultProps = exports.defaultProps = {};

var Card = function Card(_ref) {
  var ageRange = _ref.ageRange,
      _ref$badgeInline = _ref.badgeInline,
      badgeInline = _ref$badgeInline === undefined ? false : _ref$badgeInline,
      _ref$badgeInlineBorde = _ref.badgeInlineBorder,
      badgeInlineBorder = _ref$badgeInlineBorde === undefined ? false : _ref$badgeInlineBorde,
      badgeText = _ref.badgeText,
      body = _ref.body,
      _ref$colour = _ref.colour,
      colour = _ref$colour === undefined ? 'green' : _ref$colour,
      cta = _ref.cta,
      href = _ref.href,
      _ref$imageBackgroundC = _ref.imageBackgroundColour,
      imageBackgroundColour = _ref$imageBackgroundC === undefined ? '#E5EDF4' : _ref$imageBackgroundC,
      _ref$imageBackgroundS = _ref.imageBackgroundSize,
      imageBackgroundSize = _ref$imageBackgroundS === undefined ? 'contain' : _ref$imageBackgroundS,
      image = _ref.image,
      _ref$large = _ref.large,
      large = _ref$large === undefined ? false : _ref$large,
      _ref$largeImageSide = _ref.largeImageSide,
      largeImageSide = _ref$largeImageSide === undefined ? 'left' : _ref$largeImageSide,
      _ref$fadeButton = _ref.fadeButton,
      fadeButton = _ref$fadeButton === undefined ? false : _ref$fadeButton,
      onClick = _ref.onClick,
      points = _ref.points,
      price = _ref.price,
      priceOriginal = _ref.priceOriginal,
      renderAppendix = _ref.renderAppendix,
      renderImage = _ref.renderImage,
      _ref$onlyLinkInner = _ref.onlyLinkInner,
      onlyLinkInner = _ref$onlyLinkInner === undefined ? false : _ref$onlyLinkInner,
      title = _ref.title;

  var isLinkCard = !!href && (!cta || !large);
  var linkEl = isLinkCard && !onlyLinkInner;
  var linkInnerEl = isLinkCard && onlyLinkInner;

  var El = linkEl ? 'a' : 'div';
  var InnerEl = linkInnerEl ? 'a' : 'div';

  var hexColour = _paletteWonderblyPalette2.default[colour];

  var showBorder = false;

  if (large) {
    if (badgeInlineBorder) {
      showBorder = true;
    }
  } else if (badgeText) {
    if (!badgeInline || badgeInline && badgeInlineBorder) {
      showBorder = true;
    }
  }

  var hasOnClick = typeof onClick === 'function';

  return _react2.default.createElement(
    El,
    {
      className: (0, _classnames2.default)('card', _defineProperty({
        'card--has-badge': badgeText,
        'card--badge-text-dark': darkForegroundColours.indexOf(colour) > -1,
        'card--badge-inline': badgeInline,
        'card--badge-inline-border': badgeInlineBorder,
        'card--large': large,
        'card--link-card': isLinkCard
      }, 'card--large-image-' + largeImageSide, true)),
      style: {
        borderColor: hexColour,
        backgroundColor: showBorder && hexColour
      } /* Set background here, rather than badge, so we don't get artifacts during transform animation */
      , href: linkEl ? href : undefined
    },
    _react2.default.createElement(
      'div',
      { className: 'card__main' },
      badgeText && !badgeInline && !large && _react2.default.createElement(
        'div',
        { className: 'card__badge text-milli' },
        badgeText
      ),
      _react2.default.createElement(
        'div',
        { className: 'card__images' },
        typeof renderImage === 'function' ? renderImage() : _react2.default.createElement('div', {
          className: 'card__image',
          style: {
            backgroundColor: imageBackgroundColour,
            backgroundImage: 'url(' + image + ')',
            backgroundSize: imageBackgroundSize
          }
        })
      ),
      _react2.default.createElement(
        InnerEl,
        { className: 'card__inner', href: linkInnerEl ? href : undefined },
        _react2.default.createElement(
          'div',
          { className: 'card__body' },
          _react2.default.createElement(
            'div',
            { className: 'card__body-top' },
            (badgeInline || large) && _react2.default.createElement(
              'div',
              {
                className: 'card__inline-badge text-milli',
                style: { color: hexColour }
              },
              badgeText
            ),
            _react2.default.createElement(
              'span',
              { className: 'card__body-head' },
              _react2.default.createElement(
                'h5',
                { className: 'card__title text-mega' },
                title
              ),
              _react2.default.createElement(
                'div',
                { className: 'card__title-prices' },
                large && priceOriginal && _react2.default.createElement(
                  'span',
                  { className: 'card__title-price-original text-milli' },
                  priceOriginal
                ),
                large && _react2.default.createElement(
                  'span',
                  { className: 'card__title-price text-base' },
                  price
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'card__body-copy' },
              body
            ),
            large && _react2.default.createElement(
              'div',
              { className: 'card__icon-list', style: { color: hexColour } },
              _react2.default.createElement(
                _IconList2.default,
                null,
                _react2.default.createElement(
                  _IconList2.default.Item,
                  { icon: 'balloon' },
                  ageRange
                ),
                points
              )
            )
          ),
          cta && large && _react2.default.createElement(
            'div',
            { className: 'card__body-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'card__cta' },
              _react2.default.createElement(
                _Button2.default,
                {
                  colour: fadeButton ? 'green-light' : 'green',
                  raised: !fadeButton,
                  href: hasOnClick ? undefined : href,
                  onClick: hasOnClick ? onClick : undefined
                },
                cta
              )
            )
          )
        ),
        !large && _react2.default.createElement(
          'div',
          { className: 'card__detail' },
          _react2.default.createElement(
            'div',
            { className: 'card__detail-age' },
            ageRange
          ),
          _react2.default.createElement(
            'div',
            { className: 'card__detail-prices' },
            priceOriginal && _react2.default.createElement(
              'span',
              { className: 'card__detail-price-original text-milli' },
              priceOriginal
            ),
            _react2.default.createElement(
              'span',
              { className: 'card__detail-price' },
              price
            )
          )
        )
      )
    ),
    typeof renderAppendix === 'function' && _react2.default.createElement(
      'div',
      { className: 'card__appendix' },
      renderAppendix()
    )
  );
};

Card.propTypes = componentPropTypes;
Card.defaultProps = defaultProps;

exports.default = Card;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(10);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconList = __webpack_require__(24);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = {"green-light":"#BFE8DE","green":"#2CB492","green-medium":"#80D2BE","green-dark":"#176F5E","yellow-light":"#FFF0C3","yellow":"#FFCC37","yellow-medium":"#FFE087","yellow-dark":"#DDAC31","pink-light":"#FCD4D7","pink":"#F6707B","pink-medium":"#FAA9B0","pink-dark":"#7A373D","blue-light":"#B2CCE1","blue":"#69CFD5","blue-medium":"#00549a","blue-dark":"#5A6E73","red":"#F27860","red-dark":"#C65F4A","purple-light":"#D0CEE1","purple":"#645B9B","purple-medium":"#A29DC3","purple-dark":"#312D4D","orange-light":"#FCDDD0","orange":"#F48D61","orange-medium":"#F8BBA0","orange-dark":"#C65F4A","white":"#FFFFFF","stone-light":"#F5F5F0","stone":"#D8D4C7","stone-dark":"#ACA99D","almost-light":"#F2F4F5","grey-light":"#B5BCC3","grey":"#5A6E73","grey-medium":"#6B7A87","grey-dark":"#3a4d5f","almost-black":"#092137"};

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/Card.js
// module id = 1402
// module chunks = 0